import { routes } from "@constants/routes";
import { cookieKeys, getCookie, useAuth, UserTypeEnum } from "@cpj-ai/panel-npm-package";
import * as React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const { isAuthenticated } = useAuth({ userType: UserTypeEnum.USER });
  const isHijacked = getCookie(cookieKeys.hijackedJobSeeker);

  if (!isAuthenticated && !isHijacked) {
    return <Navigate to={routes.auth.signUp} state={{ from: location }} replace />;
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;
